import { render, staticRenderFns } from "./MapsGBS.vue?vue&type=template&id=7f48e5f6&scoped=true&"
import script from "./MapsGBS.vue?vue&type=script&lang=js&"
export * from "./MapsGBS.vue?vue&type=script&lang=js&"
import style0 from "./MapsGBS.vue?vue&type=style&index=0&id=7f48e5f6&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f48e5f6",
  null
  
)

export default component.exports